import { createRoute } from '@tanstack/react-router'
import { authLayoutRoute } from 'src/layouts/routes'

import { NotAccessPage } from '..'

export const route403 = createRoute({
  getParentRoute: () => authLayoutRoute,
  component: () => <NotAccessPage />,
  path: '/403'
})
